export enum CommentOptions {
    None = 1,
    Optional = 2,
    Required = 3,
}
